import { Component } from '@angular/core';
import { Steps } from '../landing-page.modal';
import { HomeComponent } from './home.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.container.html',
  styleUrls: ['./home.container.scss'],
  imports: [HomeComponent],
  standalone: true,
})
export class HomeContainer {
  steps: Steps[];

  constructor() {
    this.steps = [
      {
        index: 'step 1',
        name: 'Create Groups',
        description:
          "Start by creating groups for different aspects of your life.Wheather it's your family,roommates, or a group of friends planning a trip, our platform allows you to create custom groups for each scenario.",
      },
      {
        index: 'step 2',
        name: 'Add Expenses',
        description:
          'Once your groups are set up, adding expenses is a breeze. Simply input the details of the expense, including the amounnt, category, and who participated.',
      },
      {
        index: 'step 3',
        name: 'Automatic Calculation',
        description:
          'No more manual calculation! Out platform automatically divides the expenses equally among the participants or based on custom percentages that you set. This ensures that everyone pays their fair share without any confusion.',
      },
      {
        index: 'step 4',
        name: 'Settle Up',
        description:
          "Easily keep track of who owes what and settle up with just a few clicks. Our platform provides a clear overview of each member's balance, making it simple to reimburse or request payments.",
      },
      {
        index: 'step 5',
        name: 'Expense Insights',
        description:
          'Gain valuable insights into your spending habits with detailed reports and analytics. See where your money is going and identify areas where you can save.',
      },
      {
        index: 'step 6',
        name: 'Secure and Reliable',
        description:
          'Rest assured that your financial information is safe and secure. Focus on managing expenses withour worrying about data breaches or security issues.',
      },
    ];
  }
}
